<div class="container mt-5">
    <div class="row mb-5">
        <div class="col mb-5">
            <div class="card mb-5">
                <div class="card-header bg-primary text-white">
                    <div class="row align-items-center">
                        <p class="h3 m-0 col">Content structure</p>
                        <div class="col text-right">
                            <button type="button" class="btn btn-outline-light btn-sm u-marginBottom--medium" (click)="showHideDisableItems()">
                                <span *ngIf="hideDisableItems">Show disabled categories</span>
                                <span *ngIf="!hideDisableItems">Hide disabled categories</span>
                                <i class="fa fa-filter ml-2"></i>
                            </button>

                            <button class="btn btn-outline-light btn-sm ml-2" (click)="addItem()">
                                Create category <i class="ml-2 fa fa-plus"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col pl-0">
                            <itemconfiglist [items]="items" 
                                            [hideDisableItems]="hideDisableItems"
                                            (configItemDeleted)="onConfigItemDeleted($event)"
                                            (itemsReordered)="onItemsReordered($event)"
                                            [dropdownOptions]="dropdownOptions"></itemconfiglist>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


